<script lang="ts" setup>
defineProps<{
  isLink?: boolean
}>()

const { t } = useI18n()

const linkComponent = resolveComponent('NuxtLink')
</script>

<template>
  <component
    :is="isLink ? linkComponent : 'div'"
    :to="isLink ? { name: 'upload' } : undefined"
    class="credits-badge py-3 px-4 font-weight-bold align-center d-flex text-no-decoration"
    :class="{ 'credits-badge--clickable': isLink }"
    data-cy="credits_badge"
  >
    {{ t('global.credits_left') }}
  </component>
</template>

<style lang="scss" scoped>
.credits-badge {
  background-color: $c-purple-bg;
  color: $c-skribbleu;
  border-radius: 6px;
  font-size: $h4-font-size;
  &--clickable {
    cursor: pointer;
    transition: opacity 0.2s ease-in-out;

    &:hover {
      opacity: 80%;
    }
  }
}
</style>
